
















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import StepMixin from '@mixin/step';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            next: false,
        };
    },

    mixins: [
        StepMixin,
    ],

    methods: {
        click(option) {
            this.current.noAuthorizedToSignRequired = option;

            if (option) {
                this.$router.push(`/apply/${ this.projectId }/applicant/add-contact-question`);
            } else {
                this.$router.push(`/apply/${ this.projectId }/applicant/tekenbevoegd-vraag`);
            }
        },
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class TekenbevoegdVereist extends Vue {}

